// import { IconDefinition, IconLookup } from '@fortawesome/fontawesome-svg-core';

const prefix = 'fac';
const iconName = 'grid';
const width = 13;
const height = 13;
const ligatures = [];
const unicode = null;
const svgPathData = `
M5.5 7 C5.77614237 7 6 7.22385763 6 7.5 L6 12.5 C6 12.7761424 5.77614237 13 5.5 13 L0.5 13 C0.223857625 13 0 12.7761424 0 12.5 L0 7.5 C0 7.22385763 0.223857625 7 0.5 7 L5.5 7 Z M12.5 7 C12.7761424 7 13 7.22385763 13 7.5 L13 12.5 C13 12.7761424 12.7761424 13 12.5 13 L7.5 13 C7.22385763 13 7 12.7761424 7 12.5 L7 7.5 C7 7.22385763 7.22385763 7 7.5 7 L12.5 7 Z M5 8 L1 8 L1 12 L5 12 L5 8 Z M12 8 L8 8 L8 12 L12 12 L12 8 Z M5.5 0 C5.77614237 0 6 0.223857625 6 0.5 L6 5.5 C6 5.77614237 5.77614237 6 5.5 6 L0.5 6 C0.223857625 6 0 5.77614237 0 5.5 L0 0.5 C0 0.223857625 0.223857625 0 0.5 0 L5.5 0 Z M12.5 0 C12.7761424 0 13 0.223857625 13 0.5 L13 5.5 C13 5.77614237 12.7761424 6 12.5 6 L7.5 6 C7.22385763 6 7 5.77614237 7 5.5 L7 0.5 C7 0.223857625 7.22385763 0 7.5 0 L12.5 0 Z M5 1 L1 1 L1 5 L5 5 L5 1 Z M12 1 L8 1 L8 5 L12 5 L12 1 Z`;
// export interface CustomIconConstruct extends IconDefinition, IconLookup {}

export const faGrid = {
  // Use a prefix like 'fac' that doesn't conflict with a prefix in the standard Font Awesome styles
  // (So avoid fab, fal, fas, far, fa)
  prefix,
  iconName, // Any name you like
  icon: [
    width, // width
    height, // height
    ligatures, // ligatures
    unicode, // unicode (if relevant)
    svgPathData, // svg path data
  ],
};
